// src/config/site.js

export const SITE = {
  supportEmail: "support@veacon.app",
  helloEmail: "hello@veacon.app",

  appStoreUrl:
    "https://apps.apple.com/us/app/veacon-discover-connect/id6761872525",

  social: {
    instagram:
      "https://www.instagram.com/veacon.app?igsh=M28xMmdkNHE3N29l&utm_source=qr",
    tiktok: "https://www.tiktok.com/@veacon.app",
    discord: "https://discord.gg/Djq3s4v7X",
  },
};